import React, { useCallback, useEffect, useState } from 'react';
import { Download, Clock, MapPin, Coffee, ChevronLeft, ChevronRight, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/Button';
import { Card, CardContent } from '../components/Card';
import { MiniFAQ } from '../components/MiniFAQ';
const heroSlides = [{
  label: 'Koffiebar interieur'
}, {
  label: 'Koffie & gebak'
}, {
  label: 'Barista aan het werk'
}, {
  label: 'Zithoek'
}, {
  label: 'Vitrine met gebak'
}];
export function Coffeebar() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const nextSlide = useCallback(() => {
    setCurrentSlide(prev => (prev + 1) % heroSlides.length);
  }, []);
  const prevSlide = useCallback(() => {
    setCurrentSlide(prev => (prev - 1 + heroSlides.length) % heroSlides.length);
  }, []);
  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [nextSlide]);
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div data-id="element-360">
      {/* Hero with image slider */}
      <section className="relative bg-gray-100 border-b border-gray-300" data-id="element-361">
        <div className="relative h-[480px] md:h-[560px] overflow-hidden" data-id="element-362">
          {/* Slides */}
          {heroSlides.map((slide, index) => <div key={index} className={`absolute inset-0 border-2 border-dashed border-gray-300 flex items-center justify-center bg-gray-100 transition-opacity duration-500 ${index === currentSlide ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} data-id="element-363">
              <span className="text-gray-400 text-lg" data-id="element-364">{slide.label}</span>
            </div>)}

          {/* Title + buttons overlay */}
          <div className="absolute inset-0 flex flex-col items-center justify-center z-10 px-4 pointer-events-none" data-id="element-365">
            <div className="bg-white/90 border border-gray-200 rounded-lg px-8 py-8 md:px-12 md:py-10 text-center pointer-events-auto" data-id="element-366">
              <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-367">Koffiebar</h1>
              <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-368">
                <Button variant="primary" size="medium" onClick={() => scrollTo('menukaart')} data-id="element-369">
                  Menu
                </Button>
                <Button variant="secondary" size="medium" onClick={() => scrollTo('praktische-informatie')} data-id="element-370">
                  Contact
                </Button>
              </div>
            </div>
          </div>

          {/* Prev / Next controls */}
          <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center border border-gray-300 bg-white rounded-full hover:bg-gray-50 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-gray-300 z-10" aria-label="Vorige foto" data-id="element-371">
            <ChevronLeft size={20} data-id="element-372" />
          </button>
          <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center border border-gray-300 bg-white rounded-full hover:bg-gray-50 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-gray-300 z-10" aria-label="Volgende foto" data-id="element-373">
            <ChevronRight size={20} data-id="element-374" />
          </button>

          {/* Dot indicators */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10" data-id="element-375">
            {heroSlides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2.5 h-2.5 rounded-full border border-gray-400 transition-colors duration-150 focus:outline-none ${index === currentSlide ? 'bg-gray-700' : 'bg-white'}`} aria-label={`Ga naar foto ${index + 1}`} data-id="element-376" />)}
          </div>
        </div>
      </section>

      <div className="container mx-auto px-4" data-id="element-377">
        {/* What we offer */}
        <section className="py-16" data-id="element-378">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-center" data-id="element-379">
            Wat we aanbieden
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed text-center max-w-3xl mx-auto mb-10" data-id="element-380">
            Onze koffiebar is het kloppende hart van De Maekerij. Een gezellige
            plek waar makers samenkomen voor een goede kop koffie, een
            huisgemaakte lekkernij en inspirerende gesprekken. Of je nu even
            pauzeert tussen workshops, werkt aan je laptop, of gewoon geniet van
            de creatieve sfeer – je bent altijd welkom.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-381">
            <Card variant="outlined" data-id="element-382">
              <CardContent data-id="element-383">
                <div className="border border-dashed border-gray-300 w-16 h-16 rounded-full flex items-center justify-center bg-gray-100 mb-4" data-id="element-384">
                  <Coffee size={24} className="text-gray-400" data-id="element-385" />
                </div>
                <h3 className="font-bold mb-2" data-id="element-386">Specialty koffie</h3>
                <p className="text-sm text-gray-600" data-id="element-387">
                  Verse koffie van lokale branderijen, bereid door onze ervaren
                  barista's. Van espresso tot flat white.
                </p>
              </CardContent>
            </Card>

            <Card variant="outlined" data-id="element-388">
              <CardContent data-id="element-389">
                <div className="border border-dashed border-gray-300 w-16 h-16 rounded-full flex items-center justify-center bg-gray-100 mb-4" data-id="element-390">
                  <Coffee size={24} className="text-gray-400" data-id="element-391" />
                </div>
                <h3 className="font-bold mb-2" data-id="element-392">Huisgemaakt gebak</h3>
                <p className="text-sm text-gray-600" data-id="element-393">
                  Dagelijks vers gebakken taarten, koeken en hartige snacks.
                  Vegetarische en veganistische opties beschikbaar.
                </p>
              </CardContent>
            </Card>

            <Card variant="outlined" data-id="element-394">
              <CardContent data-id="element-395">
                <div className="border border-dashed border-gray-300 w-16 h-16 rounded-full flex items-center justify-center bg-gray-100 mb-4" data-id="element-396">
                  <Coffee size={24} className="text-gray-400" data-id="element-397" />
                </div>
                <h3 className="font-bold mb-2" data-id="element-398">Lunch & broodjes</h3>
                <p className="text-sm text-gray-600" data-id="element-399">
                  Verse broodjes, soepen en salades voor een snelle lunch tussen
                  je creatieve projecten door.
                </p>
              </CardContent>
            </Card>
          </div>
        </section>

        {/* Menu download section */}
        <section id="menukaart" className="mb-16 scroll-mt-8" data-id="element-400">
          <div className="max-w-3xl mx-auto" data-id="element-401">
            <Card variant="outlined" data-id="element-402">
              <CardContent data-id="element-403">
                <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-404">
                  <div className="border-2 border-dashed border-gray-300 w-32 h-40 flex items-center justify-center bg-gray-100 flex-shrink-0" data-id="element-405">
                    <span className="text-gray-400 text-xs text-center" data-id="element-406">
                      Menu
                      <br data-id="element-407" />
                      voorblad
                    </span>
                  </div>
                  <div className="flex-1 text-center md:text-left" data-id="element-408">
                    <h3 className="text-xl font-bold mb-2" data-id="element-409">Onze menukaart</h3>
                    <p className="text-gray-600 mb-4" data-id="element-410">
                      Download hier onze volledige menukaart met alle koffies,
                      thee, gebak en lunch opties inclusief prijzen en
                      allergenen informatie.
                    </p>
                    <Button variant="secondary" size="medium" leftIcon={<Download size={18} data-id="element-412" />} data-id="element-411">
                      Download menukaart (PDF)
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </section>

        {/* Opening hours & info */}
        <section id="praktische-informatie" className="mb-16 scroll-mt-8" data-id="element-413">
          <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center" data-id="element-414">
            Praktische informatie
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-415">
            <Card variant="outlined" data-id="element-416">
              <CardContent data-id="element-417">
                <div className="flex items-start mb-4" data-id="element-418">
                  <Clock size={20} className="text-gray-500 mr-3 mt-1 flex-shrink-0" data-id="element-419" />
                  <div data-id="element-420">
                    <h3 className="font-bold mb-3" data-id="element-421">Openingstijden</h3>
                    <div className="space-y-2 text-sm text-gray-600" data-id="element-422">
                      <div className="flex justify-between" data-id="element-423">
                        <span data-id="element-424">Maandag - Vrijdag</span>
                        <span className="font-medium" data-id="element-425">08:00 - 18:00</span>
                      </div>
                      <div className="flex justify-between" data-id="element-426">
                        <span data-id="element-427">Zaterdag</span>
                        <span className="font-medium" data-id="element-428">09:00 - 17:00</span>
                      </div>
                      <div className="flex justify-between" data-id="element-429">
                        <span data-id="element-430">Zondag</span>
                        <span className="font-medium" data-id="element-431">10:00 - 16:00</span>
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card variant="outlined" data-id="element-432">
              <CardContent data-id="element-433">
                <div className="flex items-start mb-4" data-id="element-434">
                  <MapPin size={20} className="text-gray-500 mr-3 mt-1 flex-shrink-0" data-id="element-435" />
                  <div data-id="element-436">
                    <h3 className="font-bold mb-3" data-id="element-437">Locatie & voorzieningen</h3>
                    <div className="space-y-2 text-sm text-gray-600" data-id="element-438">
                      <p data-id="element-439">Voorbeeld straat 123, Amsterdam</p>
                      <p className="pt-2 border-t border-gray-200" data-id="element-440">
                        • Gratis WiFi
                        <br data-id="element-441" />
                        • Stopcontacten bij elke tafel
                        <br data-id="element-442" />
                        • Toegankelijk voor rolstoelen
                        <br data-id="element-443" />
                        • Honden welkom
                        <br data-id="element-444" />• Contactloos betalen
                      </p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="text-center mt-8" data-id="element-445">
            <Link to="/contact" data-id="element-446">
              <Button variant="primary" size="medium" rightIcon={<ArrowRight size={18} data-id="element-448" />} data-id="element-447">
                Contacteer ons
              </Button>
            </Link>
          </div>
        </section>

        {/* Additional info */}
        <section className="mb-8" data-id="element-449">
          <div className="max-w-3xl mx-auto bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-450">
            <h3 className="font-bold mb-3" data-id="element-451">Goed om te weten</h3>
            <div className="space-y-2 text-sm text-gray-600" data-id="element-452">
              <p data-id="element-453">
                • De koffiebar is vrij toegankelijk, ook als je geen workshop
                volgt
              </p>
              <p data-id="element-454">
                • We hebben een rustige werkplek met stopcontacten voor wie wil
                werken
              </p>
              <p data-id="element-455">
                • Groepen vanaf 8 personen kunnen reserveren voor een privé
                koffietafel
              </p>
              <p data-id="element-456">
                • Cadeaubonnen zijn verkrijgbaar aan de bar of via onze webshop
              </p>
            </div>
          </div>
        </section>

        {/* FAQ section */}
        <div className="max-w-3xl mx-auto mb-8" data-id="element-457">
          <MiniFAQ category="Koffiebar" data-id="element-458" />
        </div>
      </div>
    </div>;
}